import {
  Ability,
  AbilityBuilder,
  ForcedSubject,
  MongoQuery,
  subject
} from '@casl/ability'
import {
  ACTIONS,
  SUBJECTS
} from 'features/ContractsPipelineDetails/Abilities/constants'
import { TBusinessDetails } from 'features/MyCommunity/MyOrganization/BankingSetup/types'

export type Actions = ValueOfObject<typeof ACTIONS>
export type Subjects = ValueOfObject<typeof SUBJECTS>

export type PossibleAbilities = [
  Actions,
  Subjects | (TBusinessDetails & ForcedSubject<Subjects>)
]

export type Conditions =
  | Record<PropertyKey, number | string | MongoQuery>
  | MongoQuery<Record<PropertyKey, number | string | MongoQuery>>

export type BankAccountAbility = Ability<PossibleAbilities, Conditions>

export type BankAccountAbilityBuilder = AbilityBuilder<BankAccountAbility>

export const bankAccountSubject = (type, object) =>
  subject<Subjects, TBusinessDetails>(type, { ...object })
